import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Columbus",
    route: "/cities/columbus-oh",
    tagline: "Central Ohio's trusted expedited passport hub",
    highlights: ["Capital city coverage", "Serving Westerville, Dublin, Reynoldsburg"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Cleveland",
    route: "/cities/cleveland",
    tagline: "Northeast Ohio emergency passport services",
    highlights: ["Cuyahoga County coverage", "Serving Lakewood, Parma, Shaker Heights"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Cincinnati",
    route: "/cities/cincinnati",
    tagline: "Southwest Ohio expedited passport processing",
    highlights: ["Hamilton County coverage", "Serving Northern Kentucky border area"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Toledo",
    route: "/toledo",
    tagline: "Northwest Ohio passport courier service",
    highlights: ["Lucas County coverage", "Serving Perrysburg, Sylvania, Maumee"],
    badge: null,
    status: "live",
  },
  {
    name: "Akron",
    route: "/akron",
    tagline: "Summit County expedited passport services",
    highlights: ["Rubber City area coverage", "Serving Cuyahoga Falls, Stow, Kent"],
    badge: null,
    status: "live",
  },
  {
    name: "Dayton",
    route: "/dayton",
    tagline: "Montgomery County expedited passport hub",
    highlights: ["Dayton area coverage", "Serving Kettering, Beavercreek, Centerville"],
    badge: null,
    status: "live",
  },
  {
    name: "Canton",
    route: "/cities/canton",
    tagline: "Stark County expedited passport services",
    highlights: ["Pro Football Hall of Fame area", "Serving Massillon, North Canton"],
    badge: null,
    status: "live",
  },
  {
    name: "Youngstown",
    route: "/cities/youngstown",
    tagline: "Mahoning County passport courier service",
    highlights: ["Youngstown area coverage", "Serving Boardman, Austintown"],
    badge: null,
    status: "live",
  },
  {
    name: "Lorain",
    route: "/cities/lorain",
    tagline: "Lorain County expedited passport processing",
    highlights: ["Lake Erie coastal coverage", "Serving Elyria, Amherst, Avon"],
    badge: null,
    status: "live",
  },
  {
    name: "Parma",
    route: "/cities/parma",
    tagline: "Southwest Cuyahoga County expedited passport services",
    highlights: ["Parma area coverage", "Serving Brooklyn, Seven Hills, North Royalton"],
    badge: null,
    status: "live",
  },
  {
    name: "Hamilton",
    route: "/cities/hamilton-oh",
    tagline: "Butler County expedited passport services",
    highlights: ["Hamilton area coverage", "Serving Fairfield, Oxford, Middletown"],
    badge: null,
    status: "live",
  },
  {
    name: "Springfield",
    route: "/cities/springfield-oh",
    tagline: "Clark County expedited passport processing",
    highlights: ["Springfield area coverage", "Serving Urbana, New Carlisle"],
    badge: null,
    status: "live",
  },
  {
    name: "Kettering",
    route: "/cities/kettering",
    tagline: "Montgomery County passport services",
    highlights: ["Kettering area coverage", "Serving Oakwood, Moraine, Riverside"],
    badge: null,
    status: "live",
  },
  {
    name: "Elyria",
    route: "/cities/elyria",
    tagline: "Lorain County expedited passport services",
    highlights: ["Elyria area coverage", "Serving North Ridgeville, Avon Lake"],
    badge: null,
    status: "live",
  },
  {
    name: "Middletown",
    route: "/cities/middletown-oh",
    tagline: "Butler & Warren County passport processing",
    highlights: ["Middletown area coverage", "Serving Franklin, Monroe, Trenton"],
    badge: null,
    status: "live",
  },
  {
    name: "Cuyahoga Falls",
    route: "/cities/cuyahoga-falls",
    tagline: "Summit County expedited passport services",
    highlights: ["Cuyahoga Falls area", "Serving Stow, Hudson, Falls Township"],
    badge: null,
    status: "live",
  },
  {
    name: "Newark",
    route: "/cities/newark-oh",
    tagline: "Licking County expedited passport processing",
    highlights: ["Newark area coverage", "Serving Heath, Granville, Johnstown"],
    badge: null,
    status: "live",
  },
  {
    name: "Mansfield",
    route: "/cities/mansfield",
    tagline: "Richland County expedited passport services",
    highlights: ["Mansfield area coverage", "Serving Ontario, Shelby, Lexington"],
    badge: null,
    status: "live",
  },
  {
    name: "Mentor",
    route: "/cities/mentor",
    tagline: "Lake County expedited passport processing",
    highlights: ["Mentor area coverage", "Serving Painesville, Willoughby, Eastlake"],
    badge: null,
    status: "live",
  },
  {
    name: "Beavercreek",
    route: "/cities/beavercreek",
    tagline: "Greene County expedited passport services",
    highlights: ["Beavercreek area coverage", "Serving Xenia, Fairborn, Bellbrook"],
    badge: null,
    status: "live",
  },
  {
    name: "Dublin",
    route: "/cities/dublin-oh",
    tagline: "Franklin County suburban passport services",
    highlights: ["Dublin area coverage", "Serving Powell, Hilliard, Worthington"],
    badge: null,
    status: "live",
  },
  {
    name: "Findlay",
    route: "/cities/findlay",
    tagline: "Hancock County expedited passport processing",
    highlights: ["Findlay area coverage", "Serving Bowling Green, Fostoria"],
    badge: null,
    status: "live",
  },
  {
    name: "Lima",
    route: "/cities/lima-oh",
    tagline: "Allen County expedited passport services",
    highlights: ["Lima area coverage", "Serving Shawnee Township, Elida"],
    badge: null,
    status: "live",
  },
  {
    name: "Marion",
    route: "/cities/marion-oh",
    tagline: "Marion County expedited passport processing",
    highlights: ["Marion area coverage", "Serving Prospect, Waldo, Caledonia"],
    badge: null,
    status: "live",
  },
  {
    name: "Lancaster",
    route: "/cities/lancaster-oh",
    tagline: "Fairfield County expedited passport services",
    highlights: ["Lancaster area coverage", "Serving Pickerington, Canal Winchester"],
    badge: null,
    status: "live",
  },
  {
    name: "Delaware",
    route: "/cities/delaware-oh",
    tagline: "Delaware County expedited passport processing",
    highlights: ["Delaware area coverage", "Serving Powell, Lewis Center, Sunbury"],
    badge: null,
    status: "live",
  },
  {
    name: "Medina",
    route: "/cities/medina",
    tagline: "Medina County expedited passport services",
    highlights: ["Medina area coverage", "Serving Brunswick, Wadsworth"],
    badge: null,
    status: "live",
  },
  {
    name: "Warren",
    route: "/cities/warren-oh",
    tagline: "Trumbull County expedited passport processing",
    highlights: ["Warren area coverage", "Serving Niles, Howland, Cortland"],
    badge: null,
    status: "live",
  },
  {
    name: "Strongsville",
    route: "/cities/strongsville",
    tagline: "Cuyahoga County suburban passport services",
    highlights: ["Strongsville area coverage", "Serving Berea, Middleburg Heights, Brunswick"],
    badge: null,
    status: "live",
  },
  {
    name: "Fairfield",
    route: "/cities/fairfield-oh",
    tagline: "Butler & Hamilton County passport services",
    highlights: ["Fairfield area coverage", "Serving West Chester, Liberty Township"],
    badge: null,
    status: "live",
  },
  {
    name: "Huber Heights",
    route: "/cities/huber-heights",
    tagline: "Montgomery County expedited passport services",
    highlights: ["Huber Heights area coverage", "Serving Riverside, Vandalia, Trotwood"],
    badge: null,
    status: "live",
  },
  {
    name: "Reynoldsburg",
    route: "/cities/reynoldsburg",
    tagline: "Franklin & Licking County passport services",
    highlights: ["Reynoldsburg area coverage", "Serving Pickerington, Pataskala, Blacklick"],
    badge: null,
    status: "live",
  },
  {
    name: "Wooster",
    route: "/cities/wooster",
    tagline: "Wayne County expedited passport processing",
    highlights: ["Wooster area coverage", "Serving Orrville, Rittman, Millersburg"],
    badge: null,
    status: "live",
  },
  {
    name: "Zanesville",
    route: "/cities/zanesville",
    tagline: "Muskingum County expedited passport services",
    highlights: ["Zanesville area coverage", "Serving Cambridge, New Concord, Dresden"],
    badge: null,
    status: "live",
  },
  {
    name: "Athens",
    route: "/cities/athens-oh",
    tagline: "Athens County expedited passport processing",
    highlights: ["Ohio University area", "Serving Nelsonville, The Plains, Albany"],
    badge: null,
    status: "live",
  },
  {
    name: "Bowling Green",
    route: "/cities/bowling-green-oh",
    tagline: "Wood County expedited passport services",
    highlights: ["Bowling Green State University area", "Serving Perrysburg, Rossford, Northwood"],
    badge: null,
    status: "live",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function OhioCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Ohio Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Ohio Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Ohio</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Ohio locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}